export default __webpack_public_path__ + "static/image_07-5d001ea38fa5609ca09a5045c9c9edc9.png";